export const getElementUnderCursor = (
	x: number,
	y: number,
): HTMLElement | null => {
	let element = document.elementFromPoint(x, y) as HTMLElement | null

	// Recursively traverse shadow DOM boundaries
	while (element && element.shadowRoot) {
		const shadowElement = element.shadowRoot.elementFromPoint(
			x,
			y,
		) as HTMLElement | null
		if (shadowElement) {
			element = shadowElement
		} else {
			break
		}
	}

	return element
}
